var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 7.37509V11.5418M12.5001 15.7084H12.5105M10.7188 2.02092L1.89589 16.7501C1.71398 17.0651 1.61773 17.4223 1.61671 17.7861C1.61569 18.1498 1.70994 18.5075 1.89008 18.8236C2.07022 19.1396 2.32997 19.403 2.6435 19.5874C2.95702 19.7719 3.31338 19.8711 3.67714 19.8751H21.323C21.6867 19.8711 22.0431 19.7719 22.3566 19.5874C22.6701 19.403 22.9299 19.1396 23.11 18.8236C23.2902 18.5075 23.3844 18.1498 23.3834 17.7861C23.3824 17.4223 23.2861 17.0651 23.1042 16.7501L14.2813 2.02092C14.0956 1.71479 13.8341 1.46167 13.5221 1.28601C13.2101 1.11035 12.8581 1.01807 12.5001 1.01807C12.142 1.01807 11.79 1.11035 11.478 1.28601C11.166 1.46167 10.9045 1.71479 10.7188 2.02092Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportOn);
export default __webpack_public_path__ + "static/media/report-on.802dc2bbbb789623db7c350a2720db9d.svg";
export { ForwardRef as ReactComponent };